import React from 'react';

const DashboardV2MiniCard = ({ label, value, bgClass = '' }) => (
  <div className={`v2-mini-card ${bgClass}`}>
    <div className="v2-mini-label">{label}</div>
    <div className="v2-mini-value">{value}</div>
  </div>
);

export default DashboardV2MiniCard;
